import { isPresent } from '@ember/utils'
import Component from '@glimmer/component'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { SummaryTableSchools } from 'district-ui-client/components/summary-tables/schools'
import type ReportingReSummaryTableRoute from 'district-ui-client/reporting/ui-scope/re/summary/table/route'
import RouteTemplate from 'ember-route-template'
import { not } from 'ember-truth-helpers'

interface Signature {
  Args: {
    model: ModelFor<ReportingReSummaryTableRoute>
  }
}

export class ReportingReSummaryTableRouteTemplate extends Component<Signature> {
  get schools() {
    const uiScope = this.args.model.uiScope
    if (uiScope.scope === 'district') return this.args.model.scopedData.schools
    return this.args.model.scopedData.schools.filter((school) => school.id === uiScope.id)
  }

  get isDataPresent() {
    return isPresent(this.args.model.simpleSummary)
  }

  <template>
    <DetailedPageWrapper @viewMode="table" @empty={{not this.isDataPresent}}>
      <div
        class="overflow-hidden rounded-lg shadow-[0_4px_12px_0_rgba(18,17,16,0.1)] print:rounded-none print:shadow-none"
      >
        <SummaryTableSchools
          @product={{@model.product}}
          @schools={{this.schools}}
          @schoolsData={{@model.simpleSummary.schools}}
          @averagesAndTotalsData={{@model.simpleSummary.district}}
        />
      </div>
    </DetailedPageWrapper>
  </template>
}

export default RouteTemplate(ReportingReSummaryTableRouteTemplate)
